import { Entity, validatedResource, resource} from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';


@resource("itemtag")
@validatedResource()
export class ItemTag extends Entity {
	
	id: number;
	itemId: number;
	tagId: number;
	name = null;
	
	constructor() {
		super();

		ValidationRules
			.ensure('name').required()
			.on(ItemTag);
	}


}